module.exports = __webpack_public_path__ + "static/media/product4.f3d148b3.jpg";